import store from "@/_store/store";
export function deviceWidth() {
	store.dispatch('misc/setDeviceWidth', (window.innerWidth > 0) ? window.innerWidth : screen.width);
	window.addEventListener('resize', function () {
		store.dispatch('misc/setDeviceWidth', (window.innerWidth > 0) ? window.innerWidth : screen.width);
	});
}
